import isValidFormExcludeHidden from '../helpers/isValidFormExcludeHidden'
import {
  shouldValidateFormForRegistration
} from '../../user/helpers/formHelper'

function validateAllRegistrationForms({ state, output }) {
  let forms = state.get('client.registrating.current')
  let invalidForms = Object.keys(forms).reduce((accumelator, item) => {
    if (shouldValidateFormForRegistration(item)) {
      if (!isValidFormExcludeHidden(forms[item])) {
        accumelator.push(item)
      }
    }

    return accumelator
  }, [])

  if (invalidForms.length > 0) {
    output.error({ firstInvalidForm: invalidForms[0] })
  } else {
    output.success({})
  }
}

export default validateAllRegistrationForms



// WEBPACK FOOTER //
// ./src/modules/login/actions/validateAllRegistrationForms.js